import * as React from 'react';
import {useJsonForms, withJsonFormsControlProps} from '@jsonforms/react';
import ReviewData from "../../views/ReviewData";
import {AppContext} from "../../context/AppContext";
import {useContext} from "react";
import {FormLabel, Box} from '@mui/material';

interface SummaryControlProps {
    schema: any;
    uischema: any;
    appTemplate?: any;
}

const SummaryControl = ({schema, uischema, appTemplate}: SummaryControlProps) => {
    const jsonForms = useJsonForms();

    const appContext = useContext(AppContext);

    const pages = schema.data.pages;

    return (
        <Box>
            <FormLabel color="secondary" className="form-separate-label">{uischema.label}</FormLabel>
            <ReviewData
                appData={jsonForms.core!.data}
                dataSchema={jsonForms.core!.schema}
                uiSchemas={appContext.workflow}
                showPages={pages}
                postSubmission={false}
                appTemplate={appTemplate}/>
        </Box>
    );

};

export default withJsonFormsControlProps(SummaryControl);
